/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, { useRef, useEffect, useState } from "react";
import ArgosFlexbox from "../../../components/Containers/ArgosFlexbox";
import { VALUE_KEYS } from "../constants";
import { renderUpdateURL } from "../CommonFields";
import { IProps } from "./RoarReference";


const RealWorldExample = (props: IProps) => {
  const realDescRef = useRef<HTMLInputElement>(null);
  const realUrlRef = useRef<HTMLInputElement>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (realDescRef.current) {
      realDescRef.current.value = props.object.realDesc ?? "";
    }
    if (realUrlRef.current) {
      realUrlRef.current.value = props.object.realUrl ?? "";
    }
  }, [props.object]);

  const inputStyle = {
    width: "100%",
    minWidth: "80px",
    maxWidth: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    minHeight: "48px",
  };

  /**
   * Handle the update of RWE Description text input field.
   */
  const handleUpdateDescription = () => {
    props.onDataUpdate({
      [VALUE_KEYS.REAL_DESC]: realDescRef.current?.value ?? "",
    });
  };
  
  /**
   * Handle the update of RWE URL text input field.
   */
  const handleUpdateUrl = () => {
    props.onDataUpdate({
      [VALUE_KEYS.REAL_URL]: realUrlRef.current?.value ?? "",
    });
    props.object.realUrl = realUrlRef.current?.value ?? "";
  };
  return (
    <ArgosFlexbox vertical style={{ padding: 16 }}>
      <div style={{ flex: 1, minWidth: "auto", display: "flex", alignItems: "center" }}>
        <div style={{ flexGrow: 1 }}>
          <label htmlFor={VALUE_KEYS.REAL_DESC} style={{ display: "block", marginBottom: "5px", color: "#0173CE" }}>
            Description
          </label>
          <input
            id={VALUE_KEYS.REAL_DESC}
            type="text"
            ref={realDescRef}
            defaultValue={props.object.realDesc ?? ""}
            onBlur={handleUpdateDescription}
            style={inputStyle}
          />
        </div>
      </div>
      <div style={{ flex: 1, minWidth: "auto", display: "flex", alignItems: "center" }}>
        <div style={{ flexGrow: 1 }}>
          <label htmlFor={VALUE_KEYS.REAL_URL} style={{ display: "block", marginBottom: "5px", color: "#0173CE" }}>
            URL
          </label>
          <input
            id={VALUE_KEYS.REAL_URL}
            disabled={true}
            type="text"
            ref={realUrlRef}
            value={props.object.realUrl ?? ""}
            style={inputStyle}
          />
        </div>
        {renderUpdateURL(props.object.realUrl, handleUpdateUrl, dialogOpen, setDialogOpen, realUrlRef, error, setError)}
      </div>
    </ArgosFlexbox>
  );
};

export default RealWorldExample;